import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import HeroSection from "./HeroSection";
import AboutUs from "./AboutUs";
import OurCompany from "./Company";
import Services from "./Services";
import QualitySection from "./QualitySection";
import Contact from "./Contact";
import Portfolio from "./Portfolio";

function HomeSections() {
  const location = useLocation();

  useEffect(() => {
    if (!location.state?.scrollTo) return;

    const section = location.state.scrollTo;

    const scrollToElement = () => {
      const element = document.getElementById(section);
      if (!element) return false;

      const header = document.querySelector("header");
      const headerHeight = header ? header.offsetHeight : 80;

      // Get element's absolute position from top of document
      let top = 70;
      let el = element;
      while (el) {
        top += el.offsetTop;
        el = el.offsetParent;
      }

      window.scrollTo({
        top: top - headerHeight - 10,
        behavior: "smooth",
      });

      return true;
    };

    let attempts = 0;
    const tryScroll = () => {
      attempts++;
      if (attempts > 50) return;

      const success = scrollToElement();
      if (!success) {
        setTimeout(tryScroll, 100);
      }
    };

    // Wait for AnimatePresence + full paint
    const timer = setTimeout(tryScroll, 600);
    return () => clearTimeout(timer);

  }, [location.state?.scrollTo]);

  return (
    <>
      <div id="home">
        <HeroSection />
      </div>
      <div id="about">
        <AboutUs />
        <OurCompany />
      </div>
      <div id="portfolio">
        <Portfolio />
      </div>
      <QualitySection />
      <div id="services">
        <Services />
      </div>
      <div id="contact">
        <Contact />
      </div>
    </>
  );
}

export default HomeSections;